import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron",
  "use": "chevron-usage",
  "viewBox": "0 0 13.414 8.126",
  "content": "<symbol viewBox=\"0 0 13.414 8.126\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"chevron\">\n\t<defs>\n\t\t<path id=\"chevron_thssa\" d=\"m1312 922 5.92 6 6.08-6\" />\n\t</defs>\n\t<g transform=\"translate(-.28816 -.28823)\">\n\t\t<g transform=\"translate(-1311,-921)\">\n\t\t\t<use width=\"100%\" height=\"100%\" fill=\"#ffffff\" fill-opacity=\"0\" stroke=\"currentColor\" stroke-miterlimit=\"50\" stroke-width=\"2\" xlink:href=\"#chevron_thssa\" />\n\t\t</g>\n\t</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol